var _style, _g, _defs, _path, _ellipse, _defs2, _path2, _ellipse2, _defs3, _path3, _ellipse3, _ellipse4, _defs4, _path4, _ellipse5, _ellipse6, _defs5, _path5, _ellipse7, _ellipse8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLentils({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BAD1C1;}\n\t.st1{clip-path:url(#SVGID_2_);fill:#AF9E5C;}\n\t.st2{fill:#DECC94;}\n\t.st3{clip-path:url(#SVGID_4_);fill:#AF9E5C;}\n\t.st4{clip-path:url(#SVGID_6_);fill:#F6C300;}\n\t.st5{fill:#FFD86B;}\n\t.st6{fill:#FFE3B5;}\n\t.st7{clip-path:url(#SVGID_8_);fill:#E84420;}\n\t.st8{fill:#EF7B49;}\n\t.st9{fill:#F59D32;}\n\t.st10{clip-path:url(#SVGID_10_);fill:#373841;}\n\t.st11{fill:#7A848F;}\n\t.st12{fill:#788A96;}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 100.94,
    cy: 129.96,
    r: 18.42
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#C4AF70"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.14,111.85c3.61,0.17,7.2,1.37,10.33,3.66c8.49,6.22,10.32,18.15,4.1,26.63 c-2.61,3.56-6.22,5.94-10.16,7.06c6.17,0.3,12.37-2.4,16.3-7.76c6.22-8.49,4.39-20.41-4.1-26.63 C107.68,111.2,101.59,110.3,96.14,111.85z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9337 -0.358 0.358 0.9337 -41.6671 41.4752)",
    className: "st2",
    cx: 91.18,
    cy: 133.27,
    rx: 2.74,
    ry: 10.29
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_3_",
    cx: 138.68,
    cy: 85.49,
    r: 16.93
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible",
      fill: "#C4AF70"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M146.99,70.41c2.29,2.4,3.92,5.48,4.54,8.99c1.69,9.52-4.66,18.61-14.18,20.3c-3.99,0.71-7.91,0-11.23-1.76 c3.91,4.11,9.75,6.25,15.76,5.19c9.52-1.69,15.87-10.78,14.18-20.3C155.07,77.3,151.59,72.84,146.99,70.41z"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3859 -0.9225 0.9225 0.3859 4.7052 170.0685)",
    className: "st2",
    cx: 130.1,
    cy: 81.5,
    rx: 9.45,
    ry: 2.52
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_5_",
    cx: 141.11,
    cy: 123.08,
    r: 16.93
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible",
      fill: "#FFD134"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M157.02,116.5c0.28,3.31-0.37,6.73-2.08,9.86c-4.63,8.49-15.27,11.61-23.76,6.97 c-3.56-1.94-6.17-4.94-7.66-8.4c0.48,5.66,3.7,10.97,9.05,13.9c8.49,4.63,19.12,1.51,23.76-6.97 C159.02,126.93,159.09,121.28,157.02,116.5z"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.948 -0.3184 0.3184 0.948 -29.3348 49.9708)",
    className: "st5",
    cx: 138.18,
    cy: 114.71,
    rx: 8.26,
    ry: 3.15
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8422 -0.5392 0.5392 0.8422 -37.5931 100.9889)",
    className: "st6",
    cx: 153.71,
    cy: 114.71,
    rx: 2.47,
    ry: 6.82
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_7_",
    cx: 100.51,
    cy: 86.84,
    r: 16.93
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible",
      fill: "#EA5824"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M109.11,71.92c2.24,2.45,3.81,5.56,4.36,9.08c1.5,9.55-5.03,18.51-14.58,20.01 c-4.01,0.63-7.9-0.16-11.19-1.98c3.83,4.19,9.62,6.45,15.65,5.5c9.55-1.5,16.08-10.46,14.58-20.01 C117.06,78.97,113.67,74.45,109.11,71.92z"
  }))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5574 -0.8303 0.8303 0.5574 -26.8731 113.5818)",
    className: "st8",
    cx: 93.09,
    cy: 82,
    rx: 8.26,
    ry: 3.15
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3389 -0.9408 0.9408 0.3389 1.4397 147.1039)",
    className: "st9",
    cx: 105.4,
    cy: 72.53,
    rx: 2.47,
    ry: 6.82
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_9_",
    cx: 67.77,
    cy: 109.54,
    r: 16.93
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible",
      fill: "#48555F"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M76.37,94.62c2.24,2.45,3.81,5.56,4.36,9.08c1.5,9.55-5.03,18.51-14.58,20.01 c-4.01,0.63-7.9-0.16-11.19-1.98c3.83,4.19,9.62,6.45,15.65,5.5c9.55-1.5,16.08-10.46,14.58-20.01 C84.32,101.67,80.93,97.15,76.37,94.62z"
  }))), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5574 -0.8303 0.8303 0.5574 -60.2097 96.4482)",
    className: "st11",
    cx: 60.35,
    cy: 104.69,
    rx: 8.26,
    ry: 3.15
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3389 -0.9408 0.9408 0.3389 -41.5584 131.3096)",
    className: "st12",
    cx: 72.66,
    cy: 95.23,
    rx: 2.47,
    ry: 6.82
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLentils);
export default __webpack_public_path__ + "static/media/Lentils.27e4190ba18cbb2709f9f63a315d1530.svg";
export { ForwardRef as ReactComponent };